import React, { useEffect, useState } from 'react'; 
import Sidebar from './../Layouts/Sidebar'; 
import './../../Assets/CSS/Style.css';  
import axios from 'axios';
import { BASE_URL } from './../../Environment';
import { toast } from 'react-toastify';
import { Link, useParams } from 'react-router-dom';
import { IoSearch } from 'react-icons/io5';
import { FaArrowCircleRight } from 'react-icons/fa';
      
function SubSubCategory() {  
    const { sc_slug } = useParams();  
    const [isLoading, setIsLoading] = useState(false);
    const [sub_sub_category, setSubSubCategory] = useState([]); 
    const [searchQuery, setSearchQuery] = useState(''); 
    useEffect(() => {
        document.title = 'Infomart | Sub Sub Category';
        setIsLoading(true);
        axios.get(`${BASE_URL}/sub-sub-category/${sc_slug}`, {   
            headers: { 
                'Content-Type': 'application/json'
            }
        }).then((res) => { 
            setSubSubCategory(res.data.data); 
            setIsLoading(false); 
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        }); 
    }, [sc_slug]);  
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    }; 
    const filteredSubSubCategories = sub_sub_category.filter((data) =>
        data.name.toLowerCase().includes(searchQuery.toLowerCase())
    ); 
    return (
        <div className="app"> 
            <div className="outlet">
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ?
                        <h5 className="text-center mt-5">Loading...</h5> 
                    :
                        <div className="row justify-content-center">  
                            <div className="col-12">
                                <div className="inputContainer mx-auto w-100"> 
                                    <input type="text" className="input" value={searchQuery} placeholder="Search..." onChange={handleSearchChange} />
                                    <IoSearch color="rgb(18,95,220)" /> 
                                </div>  
                                {filteredSubSubCategories.length > 0 ? ( 
                                    <ul className="mt-4">
                                        {filteredSubSubCategories?.map((data, i) => (
                                            <li className="mt-2" key={i}><FaArrowCircleRight /> <Link to={'/listing/' + data.category?.slug + '/' + data.sub_category?.slug + '/' + data.slug}>{data.name}</Link></li>
                                        ))}          
                                    </ul>   
                                ) : (
                                    <p className="mx-auto text-danger fw-bold mt-5">No results found.</p>
                                )}   
                            </div> 
                        </div>
                    }
                </div> 
            </div> 
        </div>
    );
}

export default SubSubCategory;         